<h1>Aesemic #genuary14</h1>

<p>Tribute to @culturaltutor.</p>

<p>
  The Muranichs is the most famous and puzzling manuscript collection. Thousands
  of cryptographers and code breakers, known as "Muranichers", have
  unsuccessfully tried to decipher them. But do you know their history?
</p>

<p>
  The modern history of the Muranichs starts in 1800, during the Second Italy
  Campaign (1799-1800). When leaving Genoa, letting the Austrian troops enter
  the city, general Masséna took with him whatever he could, following a
  long-established tradition.
</p>
<p>
  This included a large trunk, full of manuscripts, found in the undergrounds of
  the Doria-Spinola palace.
</p>
<p>
  Back in Paris, the trunk was opened and the manuscripts were tediously sorted
  out by Louvre scholars. Among countless wine invoices, they found some very
  strange manuscripts, which immediately caught their attention.
</p>
<p>
  Coming back from the Egyptian Campaign, Napoléon Bonaparte, who was still at
  that time only a general, was shown the manuscripts. It is recorded that he
  was amazed and kept one of the largest manuscripts for himself, which was
  never regained.
</p>
<p>
  But other similar manuscripts were soon found in the Louvre's secret
  collections.
</p>
<p>
  They had been stolen by French spies sent by Louis XIV in Murano to find out
  the secrets of the glassmakers but were never deciphered. It is believed that
  these letters were used by Murano glassmakers to secretly communicate, thus
  the "Muranichs" naming.
</p>
<p>
  Anyway, the Louvre scholars did not manage to make any meaning from these
  manuscripts. It is said that Champollion himself spent decades on it before
  switching to a more trivial task.
</p>
<p>
  Today the Muranichs are still kept in Louvre's secret collections along with
  the Iron Mask and some remaining parts of the Amber Room.
</p>
<p>
  Thousands of amateur codebreakers continue to try to reveal their secret. Yet
  we don't even know in which direction to hold the letter, and if the canes are
  used to identify the recipient, the sender, or are a part of the content of
  the message.
</p>

<img src="../genuary/img/14/1.png" alt="genuary14 by Pandelune" />
<p></p>
<img src="../genuary/img/14/4.png" alt="genuary14 by Pandelune" />
<p></p>
<img src="../genuary/img/14/5.png" alt="genuary14 by Pandelune" />
<p></p>
<img src="../genuary/img/14/6.png" alt="genuary14 by Pandelune" />
<p></p>
